import { render, staticRenderFns } from "./UserSettingsModal.vue?vue&type=template&id=12fc54f0&scoped=true&"
import script from "./UserSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc54f0",
  null
  
)

export default component.exports